﻿import Splide from '@splidejs/splide';

class CarImageCarousel extends HTMLElement {
  connectedCallback() {
    const currentIndexElement = document.getElementById('currentIndex');

    const splide = new Splide(this, {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      autoplay: true,
      speed: 500,
      interval: 5000,
      pagination: false,
    }).mount();

    setIndex(splide.index);

    splide.on('mounted move', function () {
      setIndex(splide.index);
    });

    function setIndex(value: number) {
      currentIndexElement.innerText = (value + 1).toString();
    }
  }
}

customElements.define('car-image-carousel', CarImageCarousel);
